export * from './AntipassDetail';
